import * as React from "react";
import { FlexAuto, FlexContainer } from "themes/style-components/flex";
import { Sidebar } from "./side-bar";
import { LayoutInternalContainerInner } from "./style/layout-internal-style";

export interface ILayoutInternalPageProps {
  children?:
    | JSX.Element
    | JSX.Element[]
    | React.ReactChild
    | React.ReactChild[]
    | React.ReactNode;
}

export const LayoutInternalPage = (props: ILayoutInternalPageProps) => {
  const { children } = props;
  return (
    <div className="main-page bg-gray-100">
      <div className="mx-auto py-4">
        <FlexContainer>
          <Sidebar />
          <LayoutInternalContainerInner>
            {children}
          </LayoutInternalContainerInner>
        </FlexContainer>
      </div>
    </div>
  );
};
export default LayoutInternalPage;
